export default [{
  displayValue: 'Victoria (VIC)',
  searchValue: 'vic',
}, {
  displayValue: 'New South Wales (NSW)',
  searchValue: 'nsw',
}, {
  displayValue: 'Queensland (QLD)',
  searchValue: 'qld',
}, {
  displayValue: 'Western Australia (WA)',
  searchValue: 'wa',
}, {
  displayValue: 'South Australia (SA)',
  searchValue: 'sa',
}, {
  displayValue: 'Tasmania (TAS)',
  searchValue: 'tas',
}, {
  displayValue: 'Australian Capital Territory (ACT)',
  searchValue: 'act',
}, {
  displayValue: 'Northern Territory (NT)',
  searchValue: 'nt',
}];
